import React, { useState } from "react";
import { useCSVReader } from "react-papaparse";

import { generateModulePropertyList } from "services";

import { saveFile, useCancelAsyncOnUnmount } from "utils";

import { Button, Icon, Tooltip } from "components";

export const DownloadUploadModuleProperties = ({ module, list, saving, onUpload }) => {
  const [loading, setLoading] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const { CSVReader } = useCSVReader();

  const generateList = () => {
    setLoading(true);

    generateModulePropertyList({
      module: module.module,
      type: list.type,
      signal,
    })
      .then((res) => saveFile(res, "module-properties.zip"))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Tooltip placement="bottom" title="Download this property list">
        <Button size="small" type="secondary" disabled={saving || loading} loading={saving || loading} onClick={() => generateList()}>
          <Icon iconName="tabler/download" size="s" />
        </Button>
      </Tooltip>
      <Tooltip placement="bottom" title="Upload property list">
        <CSVReader
          onUploadAccepted={onUpload}
          noDrag
          config={{ header: true, skipEmptyLines: true }}
          style={{
            dropArea: {
              border: 0,
              padding: 0,
              margin: 0,
              width: "auto",
              height: "auto",
              display: "inline-block",
            },
            progressBar: {
              display: "none !important",
              opacity: 0,
            },
          }}
        >
          {({ getRootProps }) => (
            <Button size="small" type="secondary" className="margin-left-25" disabled={saving} loading={saving} {...getRootProps()}>
              <Icon iconName="tabler/upload" size="s" />
            </Button>
          )}
        </CSVReader>
      </Tooltip>
    </>
  );
};
